import React, { Component } from 'react';
import axios from 'axios';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'animate.css/animate.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '../css/style.css';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faTwitter, faLinkedinIn, faInstagram } from '@fortawesome/free-brands-svg-icons';

class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        name: '',
        email: '',
        phone: '',
        serviceType: '',
        message: ''
      },
      isSubmitting: false
    };
  }

  handleFormChange = (e) => {
    const { name, value } = e.target;
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        [name]: value
      }
    }));
  }

handleFormSubmit = (e) => {
  e.preventDefault();
  this.setState({ isSubmitting: true });

  axios.post('https://api.sterlingtechnologies.ca/api/contact', this.state.formData)
    .then(response => {
      alert('Thank you for your message! We will get back to you soon.');
      this.setState({
        formData: {
          name: '',
          email: '',
          phone: '',
          serviceType: '',
          message: ''
        },
        isSubmitting: false
      });
    })
    .catch(error => {
      console.error('Submission error:', error);
      alert('Something went wrong. Please try again.');
      this.setState({ isSubmitting: false });
    });
}


  render() {
    const { formData, isSubmitting } = this.state;
    
    return (
      <div>
       

        {/* Hero Banner */}
        {/* <Navbar/> */}
        <section className="general-banner">
          <div className="container">
            <div className="general-content">
              <h1 className="hero-title orbitron">Contact Us</h1>
              <p className="hero-subtitle">Get in touch with our security experts today</p>
            </div>
          </div>
        </section>

        {/* Contact Content Section */}
        <section className="contact-content-section">
          <div className="container">
            <div className="row">
              {/* Contact Details */}
              <div className="col-lg-5 col-md-12 mb-4 mb-lg-0">
                <div className="contact-details-card">
                <h2 class="display-5 fw-bold mb-4">Get In Touch</h2>
                  {/* <h3 className="section-title orbitron">Get In Touch</h3> */}
                  <p className="section-subtitle">
                    Ready to secure your business? Contact Sterling Surveillance Technologies Ltd today for a consultation.
                  </p>

                  {/* Contact Items */}
                  <div className="contact-item">
                    <div className="contact-icon">
                      📍
                    </div>
                    <div className="contact-info">
                      <h6>Address</h6>
                      <div className="mb-2 secondary-color">
                            <span>British Columbia Office</span><hr></hr>
                            
                            138, Unit 8 – 6014 Vedder Road, Chilliwack, BC V2R 5P5<br />
                           
                           +1 (604) 343-5245
                          </div>
                      <br />
                          <div className="mb-2 mt-3 secondary-color">
                            <span>Alberta Office</span><hr></hr>
                           
                            Suite 315 – 919 Centre Street NW, Calgary, AB T2E 2P6<br />
                           
                            +1 (403) 992-1672
                          </div>
                    </div>
                  </div>

                  <div className="contact-item">
                    <div className="contact-icon">
                      📞
                    </div>
                    <div className="contact-info orbitron">
                      <h6>Phone</h6>
                      <p>
                        <a href="tel:+1 (403) 992-1672">+1 (403) 992-1672</a>
                      </p>
                    </div>
                  </div>

                  <div className="contact-item">
                    <div className="contact-icon">
                      ✉️
                    </div>
                    <div className="contact-info orbitron">
                      <h6>Email</h6>
                      <p>
                        <a href="mailto:info@sterlingprotection.ca">info@sterlingtechnologies.ca</a>
                      </p>
                    </div>
                  </div>

                  <div className="contact-item">
                    <div className="contact-icon">
                      🕒
                    </div>
                    <div className="contact-info orbitron">
                      <h6>Business Hours</h6>
                      <p>
                        Mon - Fri: 8:00 AM - 6:00 PM<br />
                        Emergency Services: 24/7
                      </p>
                    </div>
                  </div>

                  {/* Social Media */}
                  {/* <div>
                    <h6 className='orbitron' style={{ color: 'var(--text-primary)', fontWeight: '600', marginBottom: '15px' }}>Follow Us</h6>
                   
                    <div className="social-links">
      <a href="#" className="social-link">
        <FontAwesomeIcon icon={faFacebookF} />
      </a>
      <a href="#" className="social-link">
        <FontAwesomeIcon icon={faTwitter} />
      </a>
      <a href="#" className="social-link">
        <FontAwesomeIcon icon={faLinkedinIn} />
      </a>
      <a href="#" className="social-link">
        <FontAwesomeIcon icon={faInstagram} />
      </a>
    </div>
                  </div> */}
                </div>
              </div>

              {/* Contact Form */}
              <div className="col-lg-7 col-md-12">
                <div className="contact-form-card">
                <h2 class="display-5 fw-bold mb-4">Send Us a Message</h2>
                  {/* <h3 className="section-title orbitron">Send Us a Message</h3> */}
                  <p className="section-subtitle">
                    If you have any questions or need assistance, feel free to reach out to our support team. We're here to help you every step of the way.
                  </p>
                  
                  <div>
                    <div className="row">
                      <div className="col-md-6">
                        <input 
                          type="text" 
                          className="form-control" 
                          placeholder="Your Name" 
                          name="name"
                          value={formData.name}
                          onChange={this.handleFormChange}
                          required 
                        />
                      </div>
                      <div className="col-md-6">
                        <input 
                          type="email" 
                          className="form-control" 
                          placeholder="Email Address" 
                          name="email"
                          value={formData.email}
                          onChange={this.handleFormChange}
                          required 
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <input 
                          type="tel" 
                          className="form-control" 
                          placeholder="Phone Number" 
                          name="phone"
                          value={formData.phone}
                          onChange={this.handleFormChange}
                          required 
                        />
                      </div>
                      <div className="col-md-6">
                        <select 
                          className="form-control" 
                          name="serviceType"
                          value={formData.serviceType}
                          onChange={this.handleFormChange}
                          required
                        >
                          <option value="">Select Service Type</option>
                          <option value="surveillance">Video Surveillance</option>
                          <option value="access">Access Control</option>
                          <option value="intrusion">Intrusion Detection</option>
                          <option value="fire">Fire Safety</option>
                        </select>
                      </div>
                    </div>
                    <textarea 
                      className="form-control" 
                      rows="5" 
                      placeholder="Tell us about your security needs..." 
                      name="message"
                      value={formData.message}
                      onChange={this.handleFormChange}
                      required
                    ></textarea>
                    <div className="text-center">
                      <button 
                        type="button" 
                        className="btn btn-primary" 
                        disabled={isSubmitting}
                        onClick={this.handleFormSubmit}
                      >
                        {isSubmitting ? 'SENDING...' : 'SEND MESSAGE'}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
       
      </div>
     
    );
  }
}

export default Contact;